import React, { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import unpaidinvoice from "../../assests/images/Unpaid Invoices.png";
import rattingupImages from "../../assests/images/Rattingup (2).png";
import rattingdownImages from "../../assests/images/Rattingdown (2).png";
import mismatchImages from "../../assests/images/Mismatch.png";
import deliveriesImages from "../../assests/images/Deliveries.png";
import varianceImages from "../../assests/images/Variance.png";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
} from "recharts";

const Mismatchdata = [
  { name: "Jan", uv: 40 },
  { name: "Feb", uv: 30 },
  { name: "Mar", uv: 2000 },
  { name: "Apr" },
  { name: "May", uv: 1890 },
  { name: "Jun", uv: 2390 },
  { name: "July", uv: 3490 },
];
const deliveriesdata = [
  { name: "Jan", pv: 2400, amt: 2400 },
  { name: "Feb", pv: 1398, amt: 2210 },
  { name: "Mar", pv: 9800, amt: 2290 },
  { name: "Apr", pv: 3908, amt: 2000 },
  { name: "May", pv: 4800, amt: 2181 },
  { name: "Jun", pv: 3800, amt: 2500 },
  { name: "July", pv: 4300, amt: 2100 },
];
const invoicesdata = [
  {
    name: "July",
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Jun",
    pv: 1398,
    amt: 2210,
  },
  {
    name: "May",
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Apr",
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Mar",
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Feb",
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Jan",
    pv: 4300,
    amt: 2100,
  },
];
const data1 = [
  { name: "Group A", value: 300 },
  { name: "Group B", value: 400 },
  { name: "Group C", value: 300 },
];
const COLORS = ["#F8981D", "#006AFF", "#FF2727"];

function InvoicingDashboardTab() {
  return (
    <>
      <div class="login-forms">
        <div class="text-centers">
  <div>
  <div className="fiter_invoince_dashboard_row22">
            <div className="fiter_invoince_dashboard_row_box">
              <div className="required_react_vendor_block_dashboard">
                <label className="row_div_box_select_dashboard">Site</label>

                <div className="dashboard_site_select">
                  <select
                    class="form-select vendor_lr_dashboard"
                    aria-label="Default select example"
                    fdprocessedid="v0ghl"
                  >
                    <option>Select</option>
                    <option>Invoicing</option>
                    <option>Dashboard1</option>
                    <option>Dashboard2</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="fiter_invoince_dashboard_row_box">
              <div className="required_react_vendor_block_dashboard">
                <label className="row_div_box_select_dashboard">
                  Department
                </label>

                <div className="dashboard_site_select">
                  <select
                    class="form-select vendor_lr_dashboard"
                    aria-label="Default select example"
                    fdprocessedid="v0ghl"
                  >
                    <option>Select</option>
                    <option>Invoicing</option>
                    <option>Dashboard1</option>
                    <option>Dashboard2</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="fiter_invoince_dashboard_row_box">
              <div className="required_react_vendor_block_dashboard">
                <label className="row_div_box_select_dashboard">
                  Inv. date Range
                </label>

                <div className="dashboard_site_select">
                  <input
                    type="date"
                    class="form-control vendor_lr_dashboard"
                    fdprocessedid="75riq7"
                  />
                </div>
              </div>
            </div>
            <div className="fiter_invoince_dashboard_row_box">
              <div className="required_react_vendor_block_dashboard">
                <label className="row_div_box_select_dashboard">Vendor </label>

                <div className="dashboard_site_select">
                  <select
                    class="form-select vendor_lr_dashboard"
                    aria-label="Default select example"
                    fdprocessedid="v0ghl"
                  >
                    <option>Select</option>
                    <option>Invoicing</option>
                    <option>Dashboard1</option>
                    <option>Dashboard2</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="invoicing_dashboard_btns">
              <button type="button" class="btn clear_btn_status_block_lists">
                Clear
              </button>
              <button type="button" class="btn btn-success save_next_btns">
                Apply
              </button>
            </div>
          </div>

          <div className="invoicing_dashboard_row1">
            <div className="invoicing_dashboard_row1_box1">
              <div className="invoicing_dashboard_row1_box1_left">
                <div></div>

                <div>
                  <div className="invoicing_dashboard_row_right_bpdt">
                    <img src={unpaidinvoice} alt="" />
                    <h1 className="noPadMarg invoicing_dashboard_div_react">
                      1500
                    </h1>
                  </div>
                  <p className="noPadMarg Participated_dashboard_bpdt_div">
                    Total Invoices
                  </p>
                </div>
                <div className="invoicing_dashboard_box1_left_row2"></div>
              </div>
              <div className="invoicing_dashboard_row2_box3">
                <MoreVertIcon />
              </div>
            </div>
            <div className="invoicing_dashboard_row1_box1">
              <div className="invoicing_dashboard_row1_box1_left">
                <div></div>

                <div>
                  <div className="invoicing_dashboard_row_right_bpdt">
                    <img src={unpaidinvoice} alt="" />
                    <h1 className="noPadMarg invoicing_dashboard_div_reacts">
                      1200
                    </h1>
                  </div>
                  <p className="noPadMarg Participated_dashboard_bpdt_div">
                    Invoices Booked
                  </p>
                </div>
                <div className="invoicing_dashboard_box1_left_row2"></div>
              </div>
              <div className="invoicing_dashboard_row2_box3">
                <MoreVertIcon />
              </div>
            </div>
            <div className="invoicing_dashboard_row1_box1">
              <div className="invoicing_dashboard_row1_box1_left">
                <div></div>

                <div>
                  <div className="invoicing_dashboard_row_right_bpdt">
                    <img src={unpaidinvoice} alt="" />
                    <h1 className="noPadMarg invoicing_dashboard_div">300</h1>
                  </div>
                  <p className="noPadMarg Participated_dashboard_bpdt_div">
                    Pending for Booking
                  </p>
                </div>
                <div className="invoicing_dashboard_box1_left_row2"></div>
              </div>
              <div className="invoicing_dashboard_row2_box3">
                <MoreVertIcon />
              </div>
            </div>
            <div className="invoicing_dashboard_row1_box1">
              <div className="invoicing_dashboard_row1_box1_left">
                <div></div>

                <div>
                  <div className="invoicing_dashboard_row_right_bpdt">
                    <img src={unpaidinvoice} alt="" />
                    <h1 className="noPadMarg invoicing_dashboard_div_naq">
                      900
                    </h1>
                  </div>
                  <p className="noPadMarg Participated_dashboard_bpdt_div">
                    Paid Invoices
                  </p>
                </div>
                <div className="invoicing_dashboard_box1_left_row2"></div>
              </div>
              <div className="invoicing_dashboard_row2_box3">
                <MoreVertIcon />
              </div>
            </div>
            <div className="invoicing_dashboard_row1_box1">
              <div className="invoicing_dashboard_row1_box1_left">
                <div></div>

                <div>
                  <div className="invoicing_dashboard_row_right_bpdt">
                    <img src={unpaidinvoice} alt="" />
                    <h1 className="noPadMarg invoicing_dashboard_div_project">
                      300
                    </h1>
                  </div>
                  <p className="noPadMarg Participated_dashboard_bpdt_div">
                    Unpaid Invoices
                  </p>
                </div>
                <div className="invoicing_dashboard_box1_left_row2"></div>
              </div>
              <div className="invoicing_dashboard_row2_box3">
                <MoreVertIcon />
              </div>
            </div>
          </div>
          <div className="invoicing_dashboard_row2">
            <div className="invoicing_dashboard_row2_box2">
              <div className="invoicing_bdpt_rowq">
                <h1 className="noPadMarg Participated_bpdt_div_react">8%</h1>
                <p className="noPadMarg Participated_bpdt_invoicing_dashboard">
                  of Invoice Mismatch
                </p>
              </div>

              <div className="invoicing_dashboard_row2_box3">
                <img src={mismatchImages} alt="" />
                <MoreVertIcon />
              </div>
            </div>
            <div className="invoicing_dashboard_row2_box2">
              <div className="invoicing_bdpt_rowq">
                <h1 className="noPadMarg Participated_bpdt_div_react">82%</h1>
                <p className="noPadMarg Participated_bpdt_invoicing_dashboard">
                  of On-Time Deliveries
                </p>
              </div>

              <div className="invoicing_dashboard_row2_box3">
                <img src={deliveriesImages} alt="" />
                <MoreVertIcon />
              </div>
            </div>
            <div className="invoicing_dashboard_row2_box2">
              <div className="invoicing_bdpt_rowq">
                <h1 className="noPadMarg Participated_bpdt_div_react">+5%</h1>
                <p className="noPadMarg Participated_bpdt_invoicing_dashboard">
                  Average Cost Variance
                </p>
              </div>

              <div className="invoicing_dashboard_row2_box3">
                <img src={varianceImages} alt="" />
                <MoreVertIcon />
              </div>
            </div>
          </div>
          <div className="invoicing_dashboard_row3">
            <div className="invoicing_dashboard_row3_box3">
              <div>
                <div class="issue_rejection_invoincing_dashboard_row">
                  <p class="Participated_bpdt_div_technical_issue">
                    Invoice Mismatch
                  </p>
                  <MoreVertIcon />
                </div>
                <div className="dashboard_invoicing_technical_vendor_row">
                  <LineChart width={480} height={300} data={Mismatchdata}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Line
                      connectNulls
                      type="monotone"
                      dataKey="uv"
                      stroke="#8884d8"
                      fill="#8884d8"
                    />
                  </LineChart>
                </div>
              </div>
            </div>
            <div className="invoicing_dashboard_row3_box3">
              <div class="issue_rejection_invoincing_dashboard_row">
                <div>
                  <div class="issue_rejection_invoincing_dashboard_row">
                    <p class="Participated_bpdt_div_technical_issue">
                      On-Time Deliveries
                    </p>
                    <MoreVertIcon />
                  </div>
                  <div className="dashboard_invoicing_technical_vendor_row">
                    <BarChart width={480} height={300} data={deliveriesdata}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="pv" stackId="a" fill="#34C73B" />
                      <Bar dataKey="uv" stackId="a" fill="#82ca9d" />
                    </BarChart>
                  </div>
                </div>
              </div>
            </div>
            <div className="invoicing_dashboard_row3_box3">
              <div class="issue_rejection_invoincing_dashboard_row">
                <div>
                  <div class="issue_rejection_invoincing_dashboard_row">
                    <p class="Participated_bpdt_div_technical_issue">
                      Total vs. Paid vs. Unpaid Invoices
                    </p>
                    <MoreVertIcon />
                  </div>
                  <div className="dashboard_invoicing_technical_vendor_row">
                    <BarChart
                      layout="vertical"
                      width={480}
                      height={300}
                      data={invoicesdata}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis type="number" />
                      <YAxis dataKey="name" type="category" />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="pv" stackId="a" fill="#5B9BD5" />
                      <Bar dataKey="amt" stackId="a" fill="#ED7D31" />
                    </BarChart>
                  </div>
                </div>
              </div>
            </div>
            <div className="invoicing_dashboard_row3_box3">
              <div class="issue_rejection_invoincing_dashboard_row">
                <div>
                  <div class="issue_rejection_invoincing_dashboard_row">
                    <p class="Participated_bpdt_div_technical_issue">
                      Disputed Invoices
                    </p>
                    <MoreVertIcon />
                  </div>
                  <div className="dashboard_invoicing_technical_vendor_row">
                    <PieChart width={300} height={300}>
                      <Pie
                        data={data1}
                        innerRadius={100}
                        outerRadius={120}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {data1.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                    <table>
                      <tr>
                        <td class="bdpt_react_rejected bidding_bpdt_react_admin_no_toh">
                          <div className="bidding_admin_dashboard_react_no"></div>
                          Open Disputes
                        </td>
                        <td></td>
                        <td>110</td>
                      </tr>
                      <tr>
                        <td class="bdpt_react_rejected bidding_bpdt_react_admin_no_toh">
                          <div className="bidding_admin_dashboard_react_participate"></div>
                          Resolved Disputes
                        </td>
                        <td></td>
                        <td>80</td>
                      </tr>
                      <tr>
                        <td class="bdpt_react_rejected bidding_bpdt_react_admin_no_toh">
                          <div className="bidding_admin_dashboard_react_rejecteds"></div>
                          Pending Disputes
                        </td>
                        <td></td>
                        <td>30</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="table_row_dashboard_body_main2_table">
          <div className="admin_dashboard_row_participation_here">
          <h4 className="text_vendors_dashboard_inpie">Recent Invoice</h4>
              <div className="admin_dashboard_row_right_table">
                <div class="search_main">
                  <div id="custom-search-input">
                    <div className="input-group col-md-12">
                      <input
                        type="text"
                        className="form-control input-lg"
                        placeholder="Search here"
                        fdprocessedid="8achb"
                      />
                      <span className="input-group-btn">
                        <button
                          className="btn btn-info btn-lg"
                          type="button"
                          fdprocessedid="trsp06"
                        >
                          <span className="glyphicon glyphicon-search">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg>
                          </span>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <button className="btn_bpdt_view_row_bidding_dash">
                  View all Invoice
                </button>
              </div>
            </div>
            <div className="listing_main_row_dashboard_bpdt_block">
              <table>
                <thead>
                  <tr>
                    <th className="vendor_tabels">Invoice</th>
                    <th className="vendor_tabels">Vendor Name</th>
                    <th className="vendor_tabels">Vendor Code</th>
                    <th className="vendor_tabels">Date</th>
                    <th className="vendor_tabels">Type</th>
                    <th className="vendor_tabels">Details</th>
                    <th className="vendor_tabels">Amount</th>
                    <th className="vendor_tabels">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>INV-2024001</td>
                    <td>Siemens Energy</td>
                    <td>VND001</td>
                    <td>9-6-2024</td>
                    <td>Missing item</td>
                    <td>Invoice</td>
                    <td>₹ 12000</td>
                    <td className="reject_row_color_div_dashboard">
                      In Progress
                    </td>
                  </tr>
                  <tr>
                    <td>INV-2024002</td>
                    <td>Schneider Electric</td>
                    <td>VND002</td>
                    <td>7-6-2024</td>
                    <td>Invoice</td>
                    <td>Incorrect amount</td>
                    <td>₹ 65000</td>
                    <td className="approve_row_color">Resolved</td>
                  </tr>
                  <tr>
                    <td>INV-2024003</td>
                    <td>Hitachi Energy</td>
                    <td>VND003</td>
                    <td>7-6-2024</td>
                    <td>Invoice</td>
                    <td>Payment not received</td>
                    <td>₹24000</td>
                    <td className="pending_row_color">Pending</td>
                  </tr>
                  <tr>
                    <td>INV-2024004</td>
                    <td>GE Renewable Energy</td>
                    <td>VND004</td>
                    <td>6-6-2024</td>
                    <td>Invoice</td>
                    <td>Missing item</td>
                    <td>₹ 6000</td>
                    <td className="approve_row_color">Resolved</td>
                  </tr>
                  <tr>
                    <td>INV-2024005</td>
                    <td>Zeta Solutions</td>
                    <td>VND005</td>
                    <td>5-6-2024</td>
                    <td>Invoice</td>
                    <td>Incorrect amount</td>
                    <td>₹ 12000</td>
                    <td className="approve_row_color">Resolved</td>
                  </tr>
                  <tr>
                    <td>INV-2024006</td>
                    <td>Epsilon Enterprises</td>
                    <td>VND006</td>
                    <td>4-6-2024</td>
                    <td>Invoice</td>
                    <td>Payment not received</td>
                    <td>₹ 65000</td>
                    <td className="reject_row_color_div_dashboard">
                      In Progress
                    </td>
                  </tr>
                  <tr>
                    <td>INV-2024006</td>
                    <td>Epsilon Enterprises</td>
                    <td>VND006</td>
                    <td>4-6-2024</td>
                    <td>Invoice</td>
                    <td>Payment not received</td>
                    <td>₹ 25000</td>
                    <td className="reject_row_color_div_dashboard">
                      In Progress
                    </td>
                  </tr>
                  <tr>
                    <td>INV-2024006</td>
                    <td>Epsilon Enterprises</td>
                    <td>VND006</td>
                    <td>4-6-2024</td>
                    <td>Invoice</td>
                    <td>Payment not received</td>
                    <td>₹ 55000</td>
                    <td className="reject_row_color_div_dashboard">
                      In Progress
                    </td>
                  </tr>
                  <tr>
                    <td>INV-2024006</td>
                    <td>Epsilon Enterprises</td>
                    <td>VND006</td>
                    <td>4-6-2024</td>
                    <td>Invoice</td>
                    <td>Payment not received</td>
                    <td>₹ 85000</td>
                    <td className="reject_row_color_div_dashboard">
                      In Progress
                    </td>
                  </tr>
                  <tr>
                    <td>INV-2024006</td>
                    <td>Epsilon Enterprises</td>
                    <td>VND006</td>
                    <td>4-6-2024</td>
                    <td>Invoice</td>
                    <td>Payment not received</td>
                    <td>₹ 69000</td>
                    <td className="reject_row_color_div_dashboard">
                      In Progress
                    </td>
                  </tr>
                  <tr>
                    <td>INV-2024006</td>
                    <td>Epsilon Enterprises</td>
                    <td>VND006</td>
                    <td>4-6-2024</td>
                    <td>Invoice</td>
                    <td>Payment not received</td>
                    <td>₹ 75000</td>
                    <td className="reject_row_color_div_dashboard">
                      In Progress
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="lets_pagination_dashboard">
              <Stack spacing={2}>
                <Pagination
                  count={10}
                  renderItem={(item) => (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Stack>
            </div>
          </div>
  </div>
        </div>
      </div>
    </>
  );
}

export default InvoicingDashboardTab;
